import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Import BrowserRouter, Route, and Routes
import Home from './pages/Home';
import Footer from './components/Footer';
import Header from './components/Header';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';

function App() {
  return (
    <Router basename='/pitchbattle'>
      <div className="App">
        <Header />
        {/* Wrap Routes around Route components */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping" element={<ShippingPolicy />} />
          {/* Add more routes for other pages if needed */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
